/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Campsite } from './Campsite';
import {
    CampsiteFromJSON,
    CampsiteFromJSONTyped,
    CampsiteToJSON,
} from './Campsite';

/**
 * 
 * @export
 * @interface CreateCampsite201Response
 */
export interface CreateCampsite201Response {
    /**
     * 
     * @type {Campsite}
     * @memberof CreateCampsite201Response
     */
    data: Campsite;
}

/**
 * Check if a given object implements the CreateCampsite201Response interface.
 */
export function instanceOfCreateCampsite201Response(value: object): value is CreateCampsite201Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateCampsite201ResponseFromJSON(json: any): CreateCampsite201Response {
    return CreateCampsite201ResponseFromJSONTyped(json, false);
}

export function CreateCampsite201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCampsite201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CampsiteFromJSON(json['data']),
    };
}

export function CreateCampsite201ResponseToJSON(value?: CreateCampsite201Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': CampsiteToJSON(value['data']),
    };
}

